package one.healthium.ui.compose.theme.styles

import androidx.compose.runtime.Stable
import androidx.compose.ui.graphics.Color
import one.healthium.ui.compose.theme.black
import one.healthium.ui.compose.theme.gray_8
import one.healthium.ui.compose.theme.gray_9
import one.healthium.ui.compose.theme.red_2
import one.healthium.ui.compose.theme.white

@Stable
data class UScreenStyle(
    val choiceBackground: Color = gray_9,
    val choiceBorder: Color = Color(0xFFE0E0E0),
    val choiceBorderSelected: Color = red_2,
    val choiceIndicator: Color = black,
    val choiceIndicatorCheck: Color = white,
    val choiceIndicatorBorder: Color = Color(0xFFBDBDBD),
    val progressSegmentTrack: Color = Color(0xFFF0F0F0),
    val progressContentColor: Color = Color(0xDE000000),
    val backButtonBackground: Color = white,
    val ctaContentColor: Color = white,
    val pickerContainerColor: Color = white,
    val pickerTextColor: Color = black,
    val imagePlaceholder: Color = Color(0xFFE8E0D4),
    val notificationBackground: Color = gray_9,
    val notificationSecondaryText: Color = Color.Gray,
    val rulerTickColor: Color = gray_8,
    val rulerMajorTickColor: Color = Color(0xFFAAAAAA),
    val rulerLabelColor: Color = Color(0xFFAAAAAA),
)
